import { defineComponent } from 'vue'

interface Props {
  tData?: string
  class?: string
  onSubmit?: (payload: Event) => void
  onKeydown?: (payload: KeyboardEvent) => void
}

export default defineComponent<Props>((props: Props, context) => {
  return () => (
    <form
      t-data={props.tData}
      class={props.class}
      onSubmit={(e) => {
        e.preventDefault()
        const elm = e.target as HTMLFormElement

        if (!elm.checkValidity()) {
          elm.querySelector<HTMLInputElement>(':invalid')?.focus()

          return
        }

        props.onSubmit?.(e)
      }}
      novalidate
      onKeydown={props.onKeydown}
    >
      {context.slots.default?.()}
    </form>
  )
}, {
  name: 'VForm',
  props: [
    'tData',
    'class',
    'onSubmit',
    'onKeydown'
  ]
})
